// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2H1V18H12.5V13.998H3V3.99805H21V11H23V2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 20H12.5V22H3V20Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 12.9961H14.5V23.2886L18.7529 20.6742L23 23.2906V12.9961Z"}}]};

const SystemMarkedFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'system-marked-filled',
    ref,
    icon: element,
  },
));

SystemMarkedFilledIcon.displayName = 'SystemMarkedFilledIcon';

export default SystemMarkedFilledIcon;
